<template>
  <v-data-table
    :items-per-page="5"
    hide-default-header
    :items="fileData"
    :headers="headers"
  >
    <template #header="{ props: { headers } }">
      <thead class="v-data-table-header">
        <th
          v-for="header in headers"
          :key="header.text"
          style="padding-right: 2px"
        >
          <v-menu max-width="300px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="grey darken-1"
                elevation="0"
                v-bind="attrs"
                block
                v-on="on"
                :style="`position: relative; color: white; ${
                  buttonText(header.value)
                    ? ''
                    : 'font-style: itailc; opacity: .7; font-size: .6em;'
                }`"
              >
                {{ buttonText(header.value) || "(нет)" }}

                <v-icon
                  style="
                    position: absolute;
                    right: -18px;
                    top: 50%;
                    transform: translateY(-50%);
                    opacity: 0.4;
                  "
                >
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="item in selectionItems"
                :key="item.val"
                class="d-flex flex-grow-0"
                @click="changeCol(item.val, header.value)"
              >
                <v-list-item-title :class="item.val == null ? 'red--text' : ''">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </th>
      </thead>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    headers: [],
    fileData: [],
    menuItems: [
      { text: "Начало древа", val: "root" },
      { text: "Код", val: "code" },
      { text: "Ед.Измерения", val: "unit" },
    ],
  }),
  computed: {
    ...mapGetters(["parsed", "packageTreeColumns"]),
    selectionItems() {
      let items = [];
      for (const menuItem of this.menuItems) {
        if (this.packageTreeColumns[menuItem.val] != null) continue;
        items.push(menuItem);
      }
      items.push({ text: "Очистить поле", val: null });
      return items;
    },
  },
  methods: {
    ...mapActions(["updateCol1ByKey"]),
    buttonText(idx) {
      for (const colKey in this.packageTreeColumns) {
        if (this.packageTreeColumns[colKey] == idx) {
          let found = this.menuItems.find((item) => item.val == colKey);
          return found ? found.text : null;
        }
      }
      return null;
    },
    changeCol(key, idx) {
      for (const colKey in this.packageTreeColumns) {
        if (this.packageTreeColumns[colKey] == idx) {
          this.updateCol1ByKey({ key: colKey, val: null });
        }
      }
      if (key != null) {
        this.updateCol1ByKey({ key, val: parseInt(idx) });
      } else {
        this.updateCol1ByKey({ key, val: null });
      }
    },
  },
  mounted() {
    for (const row of this.parsed.fileData1) {
      this.fileData.push({ ...row });
    }
    for (let i = 0; i < this.parsed.csvColumnCount1; i++) {
      this.headers.push({ text: i, value: `${i}` });
    }
  },
};
</script>